import dayjs from 'dayjs';
var ageByDate = function (date) { return dayjs().diff(date, 'years'); };
export default ageByDate;
